import { z } from 'zod'

export const obstetricalSchema = z.object({
  id: z.string().optional(),
  gravida: z.string().or(z.number())
    .transform((x) => x.toString())
    .nullish()
    .default(null)
    .refine((x) => {
      return Number(x) >= 1
    }, 'Gravida must by defined'),

  para: z.string().or(z.number())
    .transform((x) => x.toString())
    .nullish()
    .default(null)
    .refine((x) => {
      return Number(x) >= 0
    }, 'Para must by defined'),

  nvd: z.string().or(z.number())
    .transform((x) => x.toString())
    .transform((x) => x.length > 0 ? x : null)
    .nullish()
    .default(null),

  cs: z.string().or(z.number())
    .transform((x) => x.toString())
    .transform((x) => x.length > 0 ? x : null)
    .nullish()
    .default(null),

  vbac: z.string().or(z.number())
    .transform((x) => x.toString())
    .transform((x) => x.length > 0 ? x : null)
    .nullish()
    .default(null)
}).refine(
  ({ para, gravida }) =>
    para && gravida,
  { message: 'One of the fields must be defined' }
)

export type ObstetricalState = z.infer<typeof obstetricalSchema>
